import React from "react";

function Color_HSL() {
  return (
    <div>
      <h1>Color_HSL Component</h1>
      <p>This is the Color HSL tutorial page content.</p>
    </div>
  );
}

export default Color_HSL;
